<section id="about" dir="rtl">
  <div class="grid-container">
    <div class="about-copy">
      <h2 class="title">درباره سامانه</h2>
      <p>
        سامانه <strong>راهداری GPS</strong> با هدف ایجاد بستری یکپارچه، امن و
        هوشمند برای ثبت‌نام، تجهیز و پایش ناوگان حمل‌ونقل جاده‌ای کشور به
        سامانه‌های موقعیت‌یاب توسعه یافته است. این سامانه با فراهم‌سازی
        زیرساخت‌های لازم برای مدیریت هوشمند اطلاعات ناوگان، زمینه تخصیص هدفمند و
        عادلانه سوخت، ارتقای فرآیندهای نظارتی، افزایش شفافیت و توسعه خدمات
        دیجیتال در بخش حمل‌ونقل جاده‌ای را فراهم می‌کند. راهداری GPS با
        بهره‌گیری از فناوری‌های نوین مکان‌یابی، تحلیل داده‌ها و پایش هوشمند،
        می‌کوشد گامی مؤثر در سامان‌دهی ناوگان حمل‌ونقل مسافری و باری، ارتقای
        بهره‌وری، افزایش ایمنی، کاهش تخلفات و در نهایت توسعه مدیریت هوشمند و
        پایدار حمل‌ونقل جاده‌ای کشور بردارد.
      </p>
    </div>
    <div class="contact-list">
      <h2 class="title">راه‌های ارتباطی</h2>

      <div>
        <ul>
          <ng-container *ngFor="let item of lst_Contact">
            <li>
              <strong>{{ item.title }}</strong>
              <span>{{ item.description | faNum }}</span>
            </li>
          </ng-container>
        </ul>
      </div>
    </div>
  </div>
</section>

<footer id="site-footer">
  <div class="inner-content">
    <div class="flex-container">
      <a href="https://rayanandisheh.com" class="copyright" target="_blank" rel="noopener noreferrer"
        >طراحی و توسعه شرکت دانش بنیان رایان اندیشه نصر</a
      >
    </div>
  </div>
</footer>
